import { render } from "./Notifications.vue?vue&type=template&id=0a12624a&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=0a12624a&scoped=true&lang=css"
import "./Notifications.vue?vue&type=style&index=1&id=0a12624a&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a12624a"]])

export default __exports__